import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';

import { AttendanceSummary } from '../../../../models/attendance';
import { getMeetById } from '../../../../service/meet';
import { getBook } from '../../../../service/book';

import { formatDateLocale } from '../../../../utils/formatDateLocale';
import { getClubNameByPathname } from '../../../../utils/club';

import Icon from '../../../../components/Icon/Icon';
import { main_color } from '../../../../styles/_variables';
import styles from './AttendanceSummaryItem.module.scss';
import { isDateWithinSevenDays } from '../../../../utils/date';
import { useEffect, useState } from 'react';


interface PropsAttendanceSumary {
  attendanceSummary: AttendanceSummary,
  clubId: number
}

type Props = Pick< PropsAttendanceSumary, 'attendanceSummary' | 'clubId'> ;

const AttendanceSummaryItem = ({ attendanceSummary, clubId }: Props) => {

  const navigate = useNavigate();
  const meetId = attendanceSummary.meetId;
  const clubName = getClubNameByPathname();
  const [details, setDetails] = useState(null);

  const {data:meet, isFetching: isFetchingMeet} = useQuery(
    ['meet', meetId],
    () => getMeetById(meetId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const {data:book, isFetching: isFetchingBook} = useQuery(
    ['book', meet],
    () => {
      if (meet?.bookId) return getBook(meet?.bookId);
      return null;
    },
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );
  
  const getDetails = () => {
    const currentDate = new Date();
    const dateMeet = new Date(attendanceSummary.dateMeet);

    if (attendanceSummary.totalMembers === 0 || attendanceSummary.totalMembers === null){
      if (currentDate < dateMeet){
        return (
          <>
            <div>O encontro ainda não aconteceu!</div>
            <div className={styles.actionIcon}>
              <button className={styles.blockButton} title="Aguarde!" disabled>
                <Icon icon="waiting" color={main_color} />
              </button>
            </div>
          </>
        );
      } 
      
      if (!isDateWithinSevenDays(attendanceSummary.dateMeet)){
        return (
          <>
            <div>Não foram registradas as presenças para este encontro. <br /> Prazo expirado!</div>
            <div className={styles.actionIcon}>
              <button className={styles.blockButton} title="Prazo expirado!" disabled>
                <Icon icon="clipboard-block" color={main_color} />
              </button>
            </div>
          </>
        );
      }

      return (
        <>
          <div>Ainda não foram registradas as presenças do encontro!</div>
          <div className={styles.actionIcon}>
            <button 
              className={styles.editButton} title="Registrar presenças!"
              onClick={() => navigate(`/club/${clubId}/${clubName}/attendances/meet/${meetId}/register`)}
            >
              <Icon icon="clipboard-plus" color={main_color} />
            </button>
          </div>
        </>
      );
    } 

    return (
      <>
        <div className={styles.textIcon}>
          <Icon icon="group" className={styles.icon} color={main_color} />
          <span>{attendanceSummary.membersWasInAttendance}/{attendanceSummary.totalMembers} clubistas presentes no encontro</span>
        </div>
        <div className={styles.actionIcon}>
          <button 
            className={styles.editButton} title="Visualizar registros!"
            onClick={() => navigate(`/club/${clubId}/${clubName}/attendances/meet/${meetId}`)}
          >
            <Icon icon="clipboard-check" color={main_color} />
          </button>
        </div>
      </>
    );
  }

  useEffect(() => {
    const details_ = getDetails();
    setDetails(details_);
  }, [attendanceSummary]);

  const isFetching = isFetchingMeet || isFetchingBook;
  if (isFetching) return null;

  return (
    <div className={styles.item} key={"attendance-sumary_"+meetId}>
      <div className={styles.headerIcon}>
        <Icon icon="calendar" className={styles.icon} color={main_color} />
        <span>{formatDateLocale(attendanceSummary.dateMeet)}</span>
      </div>
      <div className={styles.bookIcon} onClick={() => navigate(`/book/local/${meet?.bookId}`)} title="Acessar livro">
        <Icon icon="bookcase" className={styles.icon} color={main_color} />
        <span>{book?.name} ({book?.author})</span>
      </div>
      <div>
        {details}
      </div>
    </div>
  )
}

export default AttendanceSummaryItem;